/**
 * Created by joerg on 13.06.17.
 */
import React, {Component} from 'react';
import BaseDataEntry from './BaseDataEntry'
import GebaudeSrukturEntry from './GebaudeSrukturEntry'
import DetailDataEntry from './DetailDataEntry'
import Kostenanalyse from './Kostenanalyse'
import KostenanalyseBrespa from './KostenanalyseBrespa'
import KostenanalyseHF from './KostenanalyseHF'
import KostenanalyseOrtbeton from './KostenanalyseOrtbeton'
import Kurzergebnis from './Kurzergebnis'
import {inject} from 'mobx-react';

@inject('baseDataStore')
@inject('brespaAnalyseStore')
@inject('ortbetonAnalyseStore')
@inject('halbfertigAnalyseStore')
class MainEntries extends Component {
    render() {
        return (
            <div>
                <div className="row" >
                    <div className="col-md-8 col-lg-8 col-sm-12">
                        <BaseDataEntry baseDataStore={this.props.baseDataStore}/>
                    </div>

                    <div className="col-md-4 col-lg-4 col-sm-12">
                        <Kurzergebnis baseDataStore={this.props.baseDataStore} brespaAnalyseStore={this.props.brespaAnalyseStore}
                                      ortbetonAnalyseStore={this.props.ortbetonAnalyseStore} halbfertigAnalyseStore={this.props.halbfertigAnalyseStore}/>
                    </div>
                </div>

                <div className="row" >

                    <div className="col-md-12 col-lg-12 col-sm-12">
                        <KostenanalyseHF dataStore={this.props.halbfertigAnalyseStore}/>
                    </div>

                </div>
            </div>

        )
    }
}

export default MainEntries


// WEBPACK FOOTER //
// ./src/components/HFentries.js